import type { MappedNotification } from 'common/header/notifications/Notifications.types';

export function getGenericImportUrl(notification: MappedNotification, tenantCode: string) {
  return notification.resourceUid ? `/${tenantCode}/configs/monitoring/imports/${notification.resourceUid}` : undefined;
}
